import PathFindingVis from "./components/pathfindingVis/pathfindingvis";

function App() {
    return <PathFindingVis />;
}

export default App;
